"use client";

import { useEffect, useMemo } from "react";
import { useMemoizedFn } from "ahooks";
import { useShellRouter } from "@/src/hooks";
import {
  ExtensionToIframeCommonHandlers,
  IframeToExtension,
} from "./IframeToExtension";

export function useExtensionListener(
  isChromeExtension: boolean,
  windowId?: string,
  commonHandlers?: ExtensionToIframeCommonHandlers,
) {
  const router = useShellRouter();

  const navigateTo = useMemoizedFn((path: string) => {
    let targetPath = path;
    try {
      const url = new URL(path, window.location.origin);
      if (url.pathname === "/") {
        targetPath = "/" + url.search + url.hash;
      }
    } catch {
      // path 不是完整 URL，直接判断字符串
      if (path === "/") {
        targetPath = "/";
      }
    }
    router.push(targetPath);
  });

  useMemo(() => {
    if (isChromeExtension && windowId) {
      return IframeToExtension.getInstance().init(
        windowId,
        navigateTo,
        commonHandlers,
      );
    }
    return undefined;
  }, [isChromeExtension, windowId, navigateTo, commonHandlers]);

  const handleMessage = useMemoizedFn((event: MessageEvent) => {
    IframeToExtension.getInstance().handleMessage(event);
  });
  useEffect(() => {
    if (!isChromeExtension) {
      return;
    }
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
}
